export default [
    {
        name: 'exploration1',
        component: () => import('../../../components/game/days/w2d4/W2D4Exploration1.vue')
    },
    {
        name: 'game1',
        component: () => import('../../../components/game/days/w2d4/W2D4Game1.vue'),
        meta: { game: 1 }
    },
    {
        name: 'exploration2',
        component: () => import('../../../components/game/days/w2d4/W2D4Exploration2.vue')
    },
    {
        name: 'exploration3',
        component: () => import('../../../components/game/days/w2d4/W2D4Exploration3.vue')
    },
    {
        name: 'game2',
        component: () => import('../../../components/game/days/w2d4/W2D4Game2.vue'),
        meta: { game: 2 }
    },
    {
        name: 'game3',
        component: () => import('../../../components/game/days/w2d4/W2D4Game3.vue'),
        meta: { game: 3 }
    },
    {
        name: 'badge1',
        component: () => import('../../../components/game/days/w2d4/W2D4Badge1.vue')
    },
    {
        name: 'game4',
        component: () => import('../../../components/game/days/w2d4/W2D4Game4.vue'),
        meta: { game: 4 }
    },
    {
        name: 'exploration4',
        component: () => import('../../../components/game/days/w2d4/W2D4Exploration4.vue')
    },
    {
        name: 'exploration5',
        component: () => import('../../../components/game/days/w2d4/W2D4Exploration5.vue')
    },
    {
        name: 'achievements',
        component: () => import('../../../components/game/days/w2d4/W2D4Achievements.vue')
    },
    {
        name: 'offboarding',
        component: () => import('../../../components/game/days/w2d4/W2D4Offboarding.vue')
    }
];
